import settingsActions from '../../services/settings/settings-actions';
import settingsStore from '../../services/settings/settings-store';
import bootstrapLog from './bootstrap-log';

import { moduleId } from '../../../build/get-module-id';
import { ISettingsStoreSourcesStateUnparsedBackend } from '../../services/settings/settings-types';
// tslint:disable-next-line:no-var-requires no-require-imports (autogenerated)
const checkLocaleModule = require('./check-locale') as { checkLocale(): boolean };
const checkLocale = checkLocaleModule.checkLocale();

export async function getSettingsData(host: string = ''): Promise<void> {
    bootstrapLog('Settings loaded in', 'Loading settings...');
    try {
        if (checkLocale) {
            await settingsActions.getSettings([
                'user',
                'system',
                'environment',
                `i18n.js.${moduleId}js`
            ]);
            const state = settingsStore.getState();
            const locale: string =
                (state.sources && state.sources.user && state.sources.user.locale) || 'ru';
            await settingsActions.getSettings(
                ['user', 'system', 'environment', `i18n.js.${moduleId}.js`],
                host,
                locale
            );
        } else {
            await settingsActions.getSettings([
                'user',
                'system',
                'environment',
                `i18n.js.${moduleId}.js`
            ]);
        }
        bootstrapLog('Settings loaded in', 'Settings loaded');
    } catch (error) {
        bootstrapLog('Settings loaded in', 'Error loading settings:' + error);
    }
}

export async function getSettingsDataFromFilesOnly(
    host: string
): Promise<ISettingsStoreSourcesStateUnparsedBackend> {
    bootstrapLog('Settings loaded in', 'Loading settings...');
    try {
        return await settingsActions.getSettingsFromFilesOnly(host);
    } catch (error) {
        bootstrapLog('Settings loaded in', 'Error loading settings:' + error);
    }
}

export async function getLocaleMessages(keys: string[]): Promise<void> {
    bootstrapLog('I18n loaded in', 'Loading i18n...');
    try {
        await settingsActions.getSettings(['i18n.js.' + moduleId + `.js.${keys.join(',')}`]);
    } catch (error) {
        bootstrapLog('I18n loaded in', 'Error loading I18n:' + error);
    }
}

export async function getSettingsAndI18nData(): Promise<void> {
    await getSettingsData();
}

export async function getOnlyI18nData(keys: string[]): Promise<void> {
    await getLocaleMessages(keys);
}
